export function customSelect() {
    setTimeout(function (){
        if ($("select").length) {
            jcf.setOptions("Select", {
                wrapNative: false,
                fakeDropInBody: false,
                maxVisibleItems: 8
            });

            jcf.replaceAll();
        }
    },500)

}


// WEBPACK FOOTER //
// ./assets/js/modules/customSelect.js